module.exports = __webpack_public_path__ + "static/screenshot-ad872fdb94f695a32d5d36d0ddc6b9b7.png";